<template>
  <div>
    <el-card shadow="hover">
      <template slot="header">
        <div class="clearfix">
          <span>厂家管理</span>
          <div style="float: right">
            <el-button type="success" size="small" @click="handleExport" :loading="exporting">导出Excel</el-button>
            <el-button type="primary" size="small" @click="openDialog()">新建厂家</el-button>
          </div>
        </div>
      </template>

      <el-alert v-if="expiryBanner.show" :type="expiryBanner.type" :closable="false" show-icon class="mb-4"
                :title="expiryBanner.title"></el-alert>
      <el-form :inline="true" :model="searchForm" class="mb-4">
        <el-form-item label="厂家名称">
          <el-input v-model="searchForm.name" placeholder="请输入" style="width: 180px" @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="list" style="width: 100%" stripe size="small" border :row-class-name="rowClassByExpiry" @row-dblclick="row => openDialog(row)">
        <el-table-column type="expand">
          <template slot-scope="props">
            <div class="detail-panel dbl-edit" @dblclick="openDialog(props.row)" title="双击任意位置修改">
              <div class="detail-panel-title"><i class="el-icon-info"></i><span>基础信息</span></div>
              <div class="detail-card-row">
                <div class="detail-card-body cols-4">
                  <div class="dc-cell w2"><span class="dc-label">厂家名称</span><span class="dc-value">{{ props.row.name || '-' }}</span></div>
                  <div class="dc-cell w2"><span class="dc-label">地址</span><span class="dc-value">{{ props.row.address || '-' }}</span></div>
                  <div class="dc-cell w2"><span class="dc-label">营业执照</span>
                    <template v-if="splitUrls(props.row.businessLicense).length">
                      <span class="file-thumbs">
                        <template v-for="(u, i) in splitUrls(props.row.businessLicense)">
                          <el-image v-if="isImage(u)" :key="'bl'+i" :src="full(u)" :preview-src-list="splitUrls(props.row.businessLicense).map(full)" fit="cover" class="file-thumb-sm"></el-image>
                          <a v-else :key="'bla'+i" :href="full(u)" target="_blank" class="file-link-sm">{{ fileShort(u) }}</a>
                        </template>
                      </span>
                    </template>
                    <span v-else class="muted">未上传</span>
                  </div>
                  <div class="dc-cell w2"><span class="dc-label">营业执照有效期</span><span class="dc-value">{{ rangeText(props.row.businessLicenseExpiryStart, props.row.businessLicenseExpiry) }}<span v-if="dueHint(props.row.businessLicenseExpiry).label" :style="{color: dueHint(props.row.businessLicenseExpiry).color, marginLeft: '8px', fontSize: '12px', fontWeight: '600'}">（{{ dueHint(props.row.businessLicenseExpiry).label }}）</span></span></div>
                  <div class="dc-cell w2"><span class="dc-label">经营许可证</span>
                    <template v-if="splitUrls(props.row.operatingLicense).length">
                      <span class="file-thumbs">
                        <template v-for="(u, i) in splitUrls(props.row.operatingLicense)">
                          <el-image v-if="isImage(u)" :key="'ol'+i" :src="full(u)" :preview-src-list="splitUrls(props.row.operatingLicense).map(full)" fit="cover" class="file-thumb-sm"></el-image>
                          <a v-else :key="'ola'+i" :href="full(u)" target="_blank" class="file-link-sm">{{ fileShort(u) }}</a>
                        </template>
                      </span>
                    </template>
                    <span v-else class="muted">未上传</span>
                  </div>
                  <div class="dc-cell w2"><span class="dc-label">经营许可证有效期</span><span class="dc-value">{{ rangeText(props.row.operatingLicenseExpiryStart, props.row.operatingLicenseExpiry) }}<span v-if="dueHint(props.row.operatingLicenseExpiry).label" :style="{color: dueHint(props.row.operatingLicenseExpiry).color, marginLeft: '8px', fontSize: '12px', fontWeight: '600'}">（{{ dueHint(props.row.operatingLicenseExpiry).label }}）</span></span></div>
                  <template v-for="(g, gi) in parseGroups(props.row)">
                    <div class="dc-cell w2" :key="'odc'+gi"><span class="dc-label">其他资料{{ parseGroups(props.row).length > 1 ? '('+(gi+1)+')' : '' }}</span>
                      <template v-if="splitUrls(g.urls).length">
                        <span class="file-thumbs">
                          <template v-for="(u, i) in splitUrls(g.urls)">
                            <el-image v-if="isImage(u)" :key="'od'+gi+'_'+i" :src="full(u)" :preview-src-list="splitUrls(g.urls).map(full)" fit="cover" class="file-thumb-sm"></el-image>
                            <a v-else :key="'oda'+gi+'_'+i" :href="full(u)" target="_blank" class="file-link-sm">{{ fileShort(u) }}</a>
                          </template>
                        </span>
                      </template>
                      <span v-else class="muted">未上传</span>
                    </div>
                    <div class="dc-cell w2" :key="'ode'+gi"><span class="dc-label">资料有效期{{ parseGroups(props.row).length > 1 ? '('+(gi+1)+')' : '' }}</span><span class="dc-value">{{ rangeText(g.expiryStart, g.expiry) }}<span v-if="dueHint(g.expiry).label" :style="{color: dueHint(g.expiry).color, marginLeft: '8px', fontSize: '12px', fontWeight: '600'}">（{{ dueHint(g.expiry).label }}）</span></span></div>
                  </template>
                </div>
              </div>

              <template v-if="false">
              <div class="detail-panel-title"><i class="el-icon-user"></i><span>法人信息</span></div>
              <div class="detail-card-row">
                <div class="detail-card-body cols-4">
                  <div class="dc-cell"><span class="dc-label">法人姓名</span><span class="dc-value">{{ props.row.legalPerson || '-' }}</span></div>
                  <div class="dc-cell"><span class="dc-label">法人身份证</span><span class="dc-value">{{ props.row.legalIdCard || '-' }}</span></div>
                  <div class="dc-cell"><span class="dc-label">证件有效期</span><span class="dc-value">{{ rangeText(props.row.legalIdCardExpiryStart, props.row.legalIdCardExpiry) }}<span v-if="dueHint(props.row.legalIdCardExpiry).label" :style="{color: dueHint(props.row.legalIdCardExpiry).color, marginLeft: '8px', fontSize: '12px', fontWeight: '600'}">（{{ dueHint(props.row.legalIdCardExpiry).label }}）</span></span></div>
                  <div class="dc-cell"><span class="dc-label">法人电话</span><span class="dc-value">{{ props.row.legalPhone || '-' }}</span></div>
                  <div class="dc-cell"><span class="dc-label">法人职位</span><span class="dc-value">{{ props.row.legalPosition || '-' }}</span></div>
                </div>
              </div>

              <div class="detail-panel-title"><i class="el-icon-phone"></i><span>联系人信息</span></div>
              <div class="detail-card-row">
                <div class="detail-card-body cols-4">
                  <div class="dc-cell"><span class="dc-label">联系人</span><span class="dc-value">{{ props.row.contactName || '-' }}</span></div>
                  <div class="dc-cell"><span class="dc-label">联系电话</span><span class="dc-value">{{ props.row.contactPhone || '-' }}</span></div>
                  <div class="dc-cell"><span class="dc-label">联系人职位</span><span class="dc-value">{{ props.row.contactPosition || '-' }}</span></div>
                </div>
              </div>
              </template>

              <div class="detail-panel-title"><i class="el-icon-document"></i><span>其他</span></div>
              <div class="detail-card-row">
                <div class="detail-card-body cols-4">
                  <div class="dc-cell w4"><span class="dc-label">备注</span><span class="dc-value">{{ props.row.remark || '-' }}</span></div>
                  <div class="dc-cell w2"><span class="dc-label">创建时间</span><span class="dc-value">{{ formatDate(props.row.createTime) || '-' }}</span></div>
                  <div class="dc-cell w2"><span class="dc-label">更新时间</span><span class="dc-value">{{ formatDate(props.row.updateTime) || '-' }}</span></div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="厂家名称" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="address" label="地址" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="营业执照" width="110" align="center">
          <template slot-scope="scope">
            <span v-if="!splitUrls(scope.row.businessLicense).length" class="muted">-</span>
            <span v-else class="badge-count" :title="splitUrls(scope.row.businessLicense).length + ' 张/份'">
              <i class="el-icon-document"></i> {{ splitUrls(scope.row.businessLicense).length }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="经营许可证" width="110" align="center">
          <template slot-scope="scope">
            <span v-if="!splitUrls(scope.row.operatingLicense).length" class="muted">-</span>
            <span v-else class="badge-count" :title="splitUrls(scope.row.operatingLicense).length + ' 张/份'">
              <i class="el-icon-document"></i> {{ splitUrls(scope.row.operatingLicense).length }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="其他资料" width="120" align="center">
          <template slot-scope="scope">
            <span v-if="totalOtherDocsCount(scope.row) === 0" class="muted">-</span>
            <span v-else class="badge-count" :title="parseGroups(scope.row).length + ' 组 / ' + totalOtherDocsCount(scope.row) + ' 份'">
              <i class="el-icon-paperclip"></i> {{ parseGroups(scope.row).length }} 组 / {{ totalOtherDocsCount(scope.row) }} 份
            </span>
          </template>
        </el-table-column>
        <el-table-column label="资料状态" width="220" align="center">
          <template slot-scope="scope">
            <template v-if="expiryStatus(scope.row).items.length">
              <div v-for="(it, i) in expiryStatus(scope.row).items" :key="i" style="margin: 2px 0;">
                <el-tag v-if="it.type === 'expired'" type="danger" size="small">
                  <i class="el-icon-warning" style="margin-right:2px"></i>{{ it.label }}
                </el-tag>
                <el-tag v-else type="warning" size="small">
                  <i class="el-icon-warning-outline" style="margin-right:2px"></i>{{ it.label }}
                </el-tag>
              </div>
            </template>
            <el-tag v-else type="success" size="small" effect="plain">正常</el-tag>
          </template>
        </el-table-column>
        <el-table-column v-if="false" label="法人信息" min-width="200">
          <template slot-scope="scope">
            <div><span class="muted">姓名：</span>{{ scope.row.legalPerson || '-' }}<span v-if="scope.row.legalPosition" class="muted small">（{{ scope.row.legalPosition }}）</span></div>
            <div class="muted small">身份证：{{ scope.row.legalIdCard || '-' }}</div>
            <div class="muted small">电话：{{ scope.row.legalPhone || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column v-if="false" label="联系人信息" min-width="170">
          <template slot-scope="scope">
            <div><span class="muted">姓名：</span>{{ scope.row.contactName || '-' }}<span v-if="scope.row.contactPosition" class="muted small">（{{ scope.row.contactPosition }}）</span></div>
            <div class="muted small">电话：{{ scope.row.contactPhone || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="160" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="openDialog(scope.row)">修改</el-button>
            <el-button type="danger" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="mt-4">
        <el-pagination
          @size-change="s => { pageSize = s; loadList() }"
          @current-change="p => { currentPage = p; loadList() }"
          :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </el-card>

    <el-dialog :title="form.id ? '编辑厂家' : '新建厂家'" :visible.sync="dialogVisible" width="980px" top="6vh" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="form" :rules="rules" ref="form" label-width="140px" size="small" class="m-form">
        <el-row :gutter="24">
          <el-col :span="12"><el-form-item label="厂家名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入厂家名称"></el-input>
          </el-form-item></el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24"><el-form-item label="地址">
            <el-input v-model="form.address" placeholder="请输入详细地址"></el-input>
          </el-form-item></el-col>
        </el-row>
        <div class="license-group">
          <el-row :gutter="24">
            <el-col :span="24"><el-form-item label="营业执照">
              <el-upload action="#" :auto-upload="false" :show-file-list="false" multiple :on-change="(f) => appendFile(f, 'businessLicense')" :accept="DOC_ACCEPT">
                <el-button size="mini" icon="el-icon-plus">添加文件</el-button>
              </el-upload>
              <div class="file-grid">
                <div v-for="(u, i) in splitUrls(form.businessLicense)" :key="i" class="file-item">
                  <el-image v-if="isImage(u)" :src="full(u)" :preview-src-list="splitUrls(form.businessLicense).map(full)" fit="cover" class="file-thumb"></el-image>
                  <a v-else :href="full(u)" target="_blank" class="file-link">{{ fileShort(u) }}</a>
                  <i class="el-icon-close file-close" @click="removeFile('businessLicense', i)"></i>
                </div>
              </div>
            </el-form-item></el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="16"><el-form-item label="营业执照有效期">
              <el-date-picker v-model="form._businessLicenseRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                              range-separator="至" start-placeholder="起始" end-placeholder="截止" style="width:100%"
                              @change="(v) => onRangeChange(v, 'businessLicenseExpiryStart', 'businessLicenseExpiry')"></el-date-picker>
            </el-form-item></el-col>
          </el-row>
        </div>
        <div class="license-group">
          <el-row :gutter="24">
            <el-col :span="24"><el-form-item label="经营许可证">
              <el-upload action="#" :auto-upload="false" :show-file-list="false" multiple :on-change="(f) => appendFile(f, 'operatingLicense')" :accept="DOC_ACCEPT">
                <el-button size="mini" icon="el-icon-plus">添加文件</el-button>
              </el-upload>
              <div class="file-grid">
                <div v-for="(u, i) in splitUrls(form.operatingLicense)" :key="i" class="file-item">
                  <el-image v-if="isImage(u)" :src="full(u)" :preview-src-list="splitUrls(form.operatingLicense).map(full)" fit="cover" class="file-thumb"></el-image>
                  <a v-else :href="full(u)" target="_blank" class="file-link">{{ fileShort(u) }}</a>
                  <i class="el-icon-close file-close" @click="removeFile('operatingLicense', i)"></i>
                </div>
              </div>
            </el-form-item></el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="16"><el-form-item label="经营许可证有效期">
              <el-date-picker v-model="form._operatingLicenseRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                              range-separator="至" start-placeholder="起始" end-placeholder="截止" style="width:100%"
                              @change="(v) => onRangeChange(v, 'operatingLicenseExpiryStart', 'operatingLicenseExpiry')"></el-date-picker>
            </el-form-item></el-col>
          </el-row>
        </div>
        <el-form-item label="其他资料">
          <div v-for="(g, gi) in form._otherDocsGroupsList" :key="'odg'+gi" class="doc-group-card">
            <div class="doc-group-head">
              <span class="doc-group-title">第 {{ gi + 1 }} 组</span>
              <el-button size="mini" type="text" style="color:#f56c6c" icon="el-icon-delete" @click="removeOtherDocGroup(gi)">删除该组</el-button>
            </div>
            <div class="doc-group-row">
              <el-upload action="#" :auto-upload="false" :show-file-list="false" multiple
                         :on-change="(f) => appendFileToGroup(f, gi)" :accept="DOC_ACCEPT">
                <el-button size="mini" icon="el-icon-plus">添加文件</el-button>
              </el-upload>
              <div class="file-grid">
                <div v-for="(u, i) in splitUrls(g.urls)" :key="i" class="file-item">
                  <el-image v-if="isImage(u)" :src="full(u)" :preview-src-list="splitUrls(g.urls).map(full)" fit="cover" class="file-thumb"></el-image>
                  <a v-else :href="full(u)" target="_blank" class="file-link">{{ fileShort(u) }}</a>
                  <i class="el-icon-close file-close" @click="removeFileFromGroup(gi, i)"></i>
                </div>
              </div>
            </div>
            <div class="group-range-row" style="margin-top:10px">
              <span class="group-range-label">有效期：</span>
              <el-date-picker v-model="g._range" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                              range-separator="至" start-placeholder="起始" end-placeholder="截止" style="width:360px"
                              @change="(v) => onGroupRangeChange(v, gi)"></el-date-picker>
            </div>
          </div>
          <el-button class="add-doc-group-btn" size="small" type="primary" plain icon="el-icon-plus" @click="addOtherDocGroup">添加一组其他资料</el-button>
        </el-form-item>
        <template v-if="false">
        <el-divider content-position="left"><span class="divider-text">法人信息</span></el-divider>
        <el-row :gutter="24">
          <el-col :span="12"><el-form-item label="法人姓名">
            <el-input v-model="form.legalPerson" placeholder="请输入法人姓名"></el-input>
          </el-form-item></el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="16"><el-form-item label="法人身份证">
            <el-input v-model="form.legalIdCard" placeholder="请输入法人身份证号" maxlength="18"></el-input>
          </el-form-item></el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="16"><el-form-item label="证件有效期">
            <el-date-picker v-model="form._legalIdCardRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                            range-separator="至" start-placeholder="起始" end-placeholder="截止" style="width:100%"
                            @change="(v) => onRangeChange(v, 'legalIdCardExpiryStart', 'legalIdCardExpiry')"></el-date-picker>
          </el-form-item></el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12"><el-form-item label="法人电话">
            <el-input v-model="form.legalPhone" placeholder="请输入法人电话" maxlength="20"></el-input>
          </el-form-item></el-col>
          <el-col :span="12"><el-form-item label="法人职位">
            <el-input v-model="form.legalPosition" placeholder="请输入法人职位"></el-input>
          </el-form-item></el-col>
        </el-row>
        <el-divider content-position="left"><span class="divider-text">联系人信息</span></el-divider>
        <el-row :gutter="24">
          <el-col :span="12"><el-form-item label="联系人">
            <el-input v-model="form.contactName" placeholder="请输入联系人姓名"></el-input>
          </el-form-item></el-col>
          <el-col :span="12"><el-form-item label="联系电话">
            <el-input v-model="form.contactPhone" placeholder="请输入联系电话" maxlength="20"></el-input>
          </el-form-item></el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12"><el-form-item label="联系人职位">
            <el-input v-model="form.contactPosition" placeholder="请输入联系人职位"></el-input>
          </el-form-item></el-col>
        </el-row>
        </template>
        <el-row :gutter="24">
          <el-col :span="24"><el-form-item label="备注">
            <el-input v-model="form.remark" type="textarea" :rows="2" placeholder="选填"></el-input>
          </el-form-item></el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="success" @click="handleSubmit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { manufacturerApi } from '../api/api'

export default {
  name: 'Manufacturer',
  data() {
    return {
      list: [],
      searchForm: { name: '' },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      form: {},
      rules: {
        name: [{ required: true, message: '请输入厂家名称', trigger: 'blur' }]
      },
      exporting: false,
      // 多文件上传接受类型：图片 + PDF + Office 文档
      DOC_ACCEPT: 'image/*,application/pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt'
    }
  },
  mounted() {
    // 支持外部跳入时携带关键字（个人待办点击厂家行 → /manufacturer?keyword=xxx）
    const kw = this.$route && this.$route.query && this.$route.query.keyword
    if (kw) this.searchForm.name = String(kw)
    this.loadList()
  },
  computed: {
    expiryBanner() {
      const list = this.list || []
      let expired = 0, warn = 0
      list.forEach(r => {
        const s = this.expiryStatus(r)
        if (s.type === 'expired') expired++
        else if (s.type === 'warn') warn++
      })
      if (expired > 0) return { show: true, type: 'error', title: '有 ' + expired + ' 家厂家资料已过期，请尽快续期更新；' + (warn > 0 ? '另有 ' + warn + ' 家临期。' : '') }
      if (warn > 0) return { show: true, type: 'warning', title: '有 ' + warn + ' 家厂家资料将于 30 天内到期，请提前办理续期。' }
      return { show: false, type: 'info', title: '' }
    }
  },
  methods: {
    loadList() {
      const params = {}
      if (this.searchForm.name) params.name = this.searchForm.name
      manufacturerApi.getPage(this.currentPage, this.pageSize, params).then(res => {
        this.list = res.data.records || []
        this.total = res.data.total || this.list.length
      })
    },
    handleSearch() { this.currentPage = 1; this.loadList() },
    resetSearch() { this.searchForm = { name: '' }; this.handleSearch() },
    openDialog(row) {
      this.form = row ? { ...row } : {}
      // 把 start/end 字段反向拼成 daterange 数组给 picker 显示
      const pairs = [
        ['businessLicenseExpiryStart', 'businessLicenseExpiry', '_businessLicenseRange'],
        ['operatingLicenseExpiryStart', 'operatingLicenseExpiry', '_operatingLicenseRange'],
        ['legalIdCardExpiryStart', 'legalIdCardExpiry', '_legalIdCardRange']
      ]
      pairs.forEach(([s, e, k]) => {
        const sv = this.form[s], ev = this.form[e]
        this.$set(this.form, k, (sv || ev) ? [sv || ev, ev || sv] : null)
      })
      // 解析其他资料分组：优先 otherDocsGroups (JSON)，老数据兼容 otherDocs+expiry
      let groups = []
      if (this.form.otherDocsGroups) {
        try {
          const arr = JSON.parse(this.form.otherDocsGroups)
          if (Array.isArray(arr)) groups = arr.map(x => ({
            urls: x.urls || '', expiryStart: x.expiryStart || '', expiry: x.expiry || '',
            _range: (x.expiryStart || x.expiry) ? [x.expiryStart || x.expiry, x.expiry || x.expiryStart] : null
          }))
        } catch (e) {}
      }
      if (!groups.length && (this.form.otherDocs || this.form.otherDocsExpiry)) {
        const sv = this.form.otherDocsExpiryStart, ev = this.form.otherDocsExpiry
        groups.push({
          urls: this.form.otherDocs || '', expiryStart: sv || '', expiry: ev || '',
          _range: (sv || ev) ? [sv || ev, ev || sv] : null
        })
      }
      this.$set(this.form, '_otherDocsGroupsList', groups)
      this.dialogVisible = true
      this.$nextTick(() => { if (this.$refs.form) this.$refs.form.clearValidate() })
    },
    addOtherDocGroup() {
      if (!Array.isArray(this.form._otherDocsGroupsList)) this.$set(this.form, '_otherDocsGroupsList', [])
      this.form._otherDocsGroupsList.push({ urls: '', expiryStart: '', expiry: '', _range: null })
    },
    removeOtherDocGroup(idx) {
      this.form._otherDocsGroupsList.splice(idx, 1)
    },
    appendFileToGroup(file, gi) {
      if (!file.raw) return
      const fd = new FormData()
      fd.append('file', file.raw)
      axios.post('/file/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
        if (res.data && res.data.success) {
          const arr = this.splitUrls(this.form._otherDocsGroupsList[gi].urls)
          arr.push(res.data.url)
          this.$set(this.form._otherDocsGroupsList[gi], 'urls', arr.join(','))
          this.$message.success('上传成功')
        } else {
          this.$message.error((res.data && res.data.message) || '上传失败')
        }
      })
    },
    removeFileFromGroup(gi, fi) {
      const arr = this.splitUrls(this.form._otherDocsGroupsList[gi].urls)
      arr.splice(fi, 1)
      this.$set(this.form._otherDocsGroupsList[gi], 'urls', arr.join(','))
    },
    onGroupRangeChange(val, gi) {
      const g = this.form._otherDocsGroupsList[gi]
      if (Array.isArray(val) && val.length === 2) {
        this.$set(g, 'expiryStart', val[0])
        this.$set(g, 'expiry', val[1])
      } else {
        this.$set(g, 'expiryStart', '')
        this.$set(g, 'expiry', '')
      }
    },
    onRangeChange(val, startField, endField) {
      if (Array.isArray(val) && val.length === 2) {
        this.$set(this.form, startField, val[0])
        this.$set(this.form, endField, val[1])
      } else {
        this.$set(this.form, startField, null)
        this.$set(this.form, endField, null)
      }
    },
    uploadField(file, field) {
      if (!file.raw) return
      const fd = new FormData()
      fd.append('file', file.raw)
      axios.post('/file/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
        if (res.data && res.data.success) {
          this.$set(this.form, field, res.data.url)
          this.$message.success('上传成功')
        } else {
          this.$message.error((res.data && res.data.message) || '上传失败')
        }
      })
    },
    // 多文件上传：追加到 form[field]（逗号分隔多 URL）
    appendFile(file, field) {
      if (!file.raw) return
      const fd = new FormData()
      fd.append('file', file.raw)
      axios.post('/file/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
        if (res.data && res.data.success) {
          const arr = this.splitUrls(this.form[field])
          arr.push(res.data.url)
          this.$set(this.form, field, arr.join(','))
          this.$message.success('上传成功')
        } else {
          this.$message.error((res.data && res.data.message) || '上传失败')
        }
      })
    },
    removeFile(field, idx) {
      const arr = this.splitUrls(this.form[field])
      arr.splice(idx, 1)
      this.$set(this.form, field, arr.join(','))
    },
    splitUrls(s) {
      if (!s) return []
      return String(s).split(',').map(x => x.trim()).filter(Boolean)
    },
    isImage(u) {
      if (!u) return false
      return /\.(png|jpe?g|gif|webp|bmp|svg)(\?|$)/i.test(u)
    },
    fileShort(u) {
      if (!u) return ''
      const name = String(u).split('/').pop() || u
      return name.length > 20 ? name.slice(0, 17) + '...' : name
    },
    rangeText(start, end) {
      if (!start && !end) return '-'
      return (start || '?') + ' 至 ' + (end || '?')
    },
    /** 单个有效期的到期提示：返回 {label, color}，过期红、临期黄、正常隐藏 */
    dueHint(end) {
      if (!end) return { label: '', color: '' }
      const d = new Date(end)
      if (isNaN(d.getTime())) return { label: '', color: '' }
      const today = new Date(); today.setHours(0, 0, 0, 0)
      const days = Math.round((d - today) / (24 * 3600 * 1000))
      if (days < 0) return { label: '已过期 ' + Math.abs(days) + ' 天', color: '#f56c6c' }
      if (days <= 30) return { label: days + ' 天后到期', color: '#e6a23c' }
      return { label: '', color: '' }
    },
    totalOtherDocsCount(row) {
      return this.parseGroups(row).reduce((s, g) => s + this.splitUrls(g.urls).length, 0)
    },
    /** 解析其他资料分组：优先 otherDocsGroups JSON，否则 fallback 老 otherDocs 字段为单组 */
    parseGroups(row) {
      if (row && row.otherDocsGroups) {
        try {
          const arr = JSON.parse(row.otherDocsGroups)
          if (Array.isArray(arr) && arr.length) return arr.map(x => ({
            urls: x.urls || '', expiryStart: x.expiryStart || '', expiry: x.expiry || ''
          }))
        } catch (e) {}
      }
      if (row && (row.otherDocs || row.otherDocsExpiry)) {
        return [{ urls: row.otherDocs || '', expiryStart: row.otherDocsExpiryStart || '', expiry: row.otherDocsExpiry || '' }]
      }
      return []
    },
    /** 扫描所有有效期，返回 {type, label, days, items}
     *  - items: 全部需要提示的项 [{label,type,days}]（过期在前，按到期顺序排）
     *  - type/label/days: 最严重那一条（向后兼容 banner / 行底色）
     */
    expiryStatus(row) {
      const WARN_DAYS = 30
      // 法人信息列已隐藏，资料状态不扫法人身份证
      const ends = [
        { label: '营业执照', d: row.businessLicenseExpiry },
        { label: '经营许可证', d: row.operatingLicenseExpiry }
      ]
      const groups = this.parseGroups(row)
      groups.forEach((g, i) => {
        ends.push({ label: '其他资料' + (groups.length > 1 ? '(' + (i + 1) + ')' : ''), d: g.expiry })
      })
      const filtered = ends.filter(x => x.d).map(x => ({ label: x.label, d: new Date(x.d) })).filter(x => !isNaN(x.d.getTime()))
      if (!filtered.length) return { type: 'normal', label: '正常', days: null, items: [] }
      const today = new Date(); today.setHours(0, 0, 0, 0)
      const all = filtered.map(x => {
        const days = Math.round((x.d - today) / (24 * 3600 * 1000))
        if (days < 0) return { label: x.label + ' 已过期 ' + Math.abs(days) + ' 天', type: 'expired', days }
        if (days <= WARN_DAYS) return { label: x.label + ' ' + days + ' 天后到期', type: 'warn', days }
        return { label: x.label, type: 'normal', days }
      })
      const items = all.filter(x => x.type !== 'normal').sort((a, b) => a.days - b.days)
      if (!items.length) return { type: 'normal', label: '正常', days: all[0] ? all[0].days : null, items: [] }
      const first = items[0]
      return { type: first.type, label: first.label, days: first.days, items }
    },
    /** 行级背景：已过期=浅红，临期=浅黄 */
    rowClassByExpiry({ row }) {
      const s = this.expiryStatus(row)
      if (s.type === 'expired') return 'row-expired'
      if (s.type === 'warn') return 'row-warn'
      return ''
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        // 序列化"其他资料分组"到 otherDocsGroups（JSON），剔除空组
        const list = Array.isArray(this.form._otherDocsGroupsList) ? this.form._otherDocsGroupsList : []
        const cleaned = list
          .map(g => ({ urls: (g.urls || '').trim(), expiryStart: g.expiryStart || '', expiry: g.expiry || '' }))
          .filter(g => g.urls || g.expiryStart || g.expiry)
        this.form.otherDocsGroups = cleaned.length ? JSON.stringify(cleaned) : ''
        // 同步老字段（取第一组）以维持兼容（列表等仍可读 row.otherDocs/otherDocsExpiry）
        const first = cleaned[0] || { urls: '', expiryStart: '', expiry: '' }
        this.form.otherDocs = first.urls
        this.form.otherDocsExpiryStart = first.expiryStart || null
        this.form.otherDocsExpiry = first.expiry || null
        const req = this.form.id ? manufacturerApi.update(this.form) : manufacturerApi.add(this.form)
        req.then(res => {
          if (res.data) {
            this.$message.success(this.form.id ? '更新成功' : '新建成功')
            this.dialogVisible = false
            this.loadList()
          } else {
            this.$message.error('操作失败')
          }
        })
      })
    },
    handleDelete(id) {
      this.$confirm('确定要删除该厂家吗？', '提示', { type: 'warning' }).then(() => {
        manufacturerApi.delete(id).then(res => {
          if (res.data) {
            this.$message.success('删除成功')
            this.loadList()
          }
        })
      }).catch(() => {})
    },
    handleExport() {
      this.exporting = true
      manufacturerApi.exportExcel().then(res => {
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = '厂家列表_' + new Date().toISOString().slice(0, 10) + '.xlsx'
        link.click()
      }).finally(() => { this.exporting = false })
    },
    full(url) {
      if (!url) return ''
      if (url.startsWith('http') || url.startsWith('data:')) return url
      // axios baseURL 形如 http://localhost:8090/api 或 https://chb.bjzkbh.com/api，去掉末尾 /api 拼上 url
      const base = (axios.defaults.baseURL || '').replace(/\/api\/?$/, '')
      return base + url
    },
    formatDate(v) { return v ? String(v).replace('T', ' ').slice(0, 10) : '' }
  }
}
</script>

<style scoped>
.mb-4 { margin-bottom: 16px; }
.mt-4 { margin-top: 16px; text-align: right; }
.muted { color: #909399; font-size: 12px; }

.detail-panel { padding: 14px 24px 18px; background: linear-gradient(180deg,#fafcff 0%,#f5f7fa 100%); border-top: 1px dashed #dcdfe6; }
.detail-panel-title { display: flex; align-items: center; gap: 6px; color: #303133; font-size: 13px; font-weight: 600; margin: 4px 0 12px; }
.detail-panel-title i { color: #409eff; }
.detail-card-row { background: #fff; border: 1px solid #ebeef5; border-radius: 6px; box-shadow: 0 1px 2px rgba(0,0,0,0.02); padding: 12px 14px; margin-bottom: 12px; }
.detail-card-body { display: grid; gap: 8px; }
.detail-card-body.cols-4 { grid-template-columns: repeat(4, 1fr); }
.dc-cell { display: flex; justify-content: flex-start; align-items: center; gap: 8px; padding: 6px 10px; background: #f8f9fb; border-radius: 4px; }
.dc-cell.w2 { grid-column: span 2; }
.dc-cell.w4 { grid-column: span 4; }
.dc-label { color: #909399; font-size: 12px; flex-shrink: 0; }
.dc-label::after { content: '：'; }
.dc-value { color: #303133; font-size: 13px; font-weight: 500; }
.small { font-size: 12px; }
.divider-text { color: #606266; font-size: 13px; font-weight: 500; }
.dbl-edit { cursor: pointer; transition: background .15s; }
.dbl-edit:hover { background: #f0f7ff; }

/* 多文件上传 grid（弹窗内） */
.file-grid { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 6px; }
.file-item { position: relative; padding: 4px 6px; background: #f5f7fa; border-radius: 4px; max-width: 200px; }
.file-thumb { width: 60px; height: 60px; border-radius: 4px; display: block; }
.file-link { font-size: 12px; color: #409eff; text-decoration: none; word-break: break-all; }
.file-close { position: absolute; top: -6px; right: -6px; cursor: pointer; background: #fff; border-radius: 50%; color: #f56c6c; font-size: 14px; padding: 2px; box-shadow: 0 1px 3px rgba(0,0,0,0.2); }

/* 列表/展开行内的多文件缩略（小一号） */
.file-thumbs { display: inline-flex; flex-wrap: wrap; gap: 6px; }
.file-thumb-sm { width: 36px; height: 36px; border-radius: 4px; }
.file-link-sm { font-size: 12px; color: #409eff; text-decoration: none; padding: 2px 6px; background: #ecf5ff; border-radius: 3px; }

/* 列表里"营业执照/经营许可证/其他资料"列的份数 badge */
.badge-count { display: inline-flex; align-items: center; gap: 4px; padding: 2px 8px; background: #ecf5ff; color: #409eff; border-radius: 10px; font-size: 12px; font-weight: 600; }

.dc-cell.w3 { grid-column: span 3; }

/* 其他资料分组卡片 */
.doc-group-card { border: 1px solid #ebeef5; border-radius: 6px; padding: 10px 12px; margin-bottom: 10px; background: #fafbfc; }
.doc-group-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
.doc-group-title { color: #606266; font-weight: 600; font-size: 13px; }
/* 改纵向：上传按钮在上，已上传文件在下；有效期在下一行 */
.doc-group-row { display: flex; flex-direction: column; align-items: flex-start; gap: 6px; }
.doc-group-row .file-grid { width: 100%; margin-top: 0; }
.doc-group-row > .group-range-row { display: flex; align-items: center; gap: 8px; width: 100%; }
.group-range-label { color: #303133; font-size: 14px; font-weight: 600; white-space: nowrap; }
/* 「添加一组其他资料」按钮：字体白色 */
.add-doc-group-btn,
.add-doc-group-btn:hover,
.add-doc-group-btn:focus { color: #ffffff !important; }
/* 营业执照/经营许可证 各自和有效期视觉成组，组间用底分隔线 + 间距 */
.license-group { padding-bottom: 6px; margin-bottom: 16px; border-bottom: 1px dashed #ebeef5; }
.license-group:last-of-type { border-bottom: none; margin-bottom: 8px; }

/* 厂家资料临期 / 已过期行整行底色提示 */
::v-deep .el-table .row-expired td { background: #fef0f0 !important; }
::v-deep .el-table .row-expired:hover > td { background: #fde2e2 !important; }
::v-deep .el-table .row-warn td { background: #fdf6ec !important; }
::v-deep .el-table .row-warn:hover > td { background: #faecd8 !important; }
</style>
